import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import Lesson from '@/pages/Lesson'
import Feishu from '@/pages/Feishu'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: Login
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/lesson',
      component: Lesson
    },
    {
      path: '/freecourses',
      component: Feishu
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.path === '/login' || to.path === '/freecourses') {
    next()
  } else {
    if(localStorage.getItem('userId')) { 
      next()
    }else {
      next({
        path:'/login'
      })
    }
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js